<script setup lang="ts">
  import type { RoutedCustomerViewComponentProps } from '@/types';
  import useCustomerStore from '@/store/customer.store';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import { useI18n } from 'vue-i18n';
  import { computed, type UnwrapRef, useTemplateRef } from 'vue';
  import type {
    ModifyAssistiveDevicesExposed,
  } from '@/components/customerProfilePage/ModifyAssistiveDevices/modifyAssistiveDevices';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader.ts';

  defineOptions({ name: 'ModifyAssistiveDevicesView' });

  defineProps<RoutedCustomerViewComponentProps>();

  const controllerRef = useTemplateRef<UnwrapRef<ModifyAssistiveDevicesExposed>>('controllerRef');
  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();
  const { customer } = useCustomerStore();
  const { t } = useI18n();

  const ModifyAssistiveDevicesController = getAsyncComponentWithLoader(() => import('@/components/customerProfilePage/ModifyAssistiveDevices/ModifyAssistiveDevicesController.vue'));

  const controllerIsSubmitting = computed<boolean>(() => {
    return controllerRef.value?.isSubmitting ?? false;
  });
</script>

<template>
  <PageContent :is-status-box-opened="isStatusBoxOpened">
    <template
      v-if="!controllerIsSubmitting"
      #header
    >
      <h1 class="md:container">
        {{ t('pages.modifyAssistiveDevicesView.title') }}
      </h1>
      <div class="flex flex-col gap-4 rounded border border-blue-accessible bg-blue-extra-light px-4 py-5 text-center md:container md:px-8 md:py-6">
        <p>{{ t('pages.modifyAssistiveDevicesView.headerBox.content') }}</p>
      </div>
    </template>
    <ModifyAssistiveDevicesController
      ref="controllerRef"
      v-bind="$props"
      :devices="customer.assistiveDevices"
    />
  </PageContent>
</template>
